import {
 Box,
 Text,
 Accordion,
 AccordionItem,
 AccordionButton,
 AccordionIcon,
 AccordionPanel,
 Stack,
} from '@chakra-ui/react';
import VideoFrame from './VideoFrame';

export default function QuestionHelper({ description, videoUrl }) {
 const isURL = (url) => {
  const pattern = new RegExp(
   /^(?:https?:\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z]{2,})(?:\/[^/]+)*/i
  );
  return pattern.test(url);
 };

 const validUrl = videoUrl && isURL(videoUrl) ? videoUrl : null;

 return (
  <Accordion allowToggle>
   <AccordionItem w='100%' bg='#F4F7F9' border='none' borderRadius='8px'>
    {({ isExpanded }) => (
     <>
      <AccordionButton w='100%' h='54px' p='12px' border='none' borderRadius='8px'>
       <Box as='span' flex='1' textAlign='left' fontSize='sm' fontWeight={600}>
        Como responder essa pergunta?
       </Box>
       <AccordionIcon />
      </AccordionButton>

      <AccordionPanel p='4px 12px 12px'>
       {!description && (
        <Text fontSize='sm' lineHeight='28px' fontWeight={500}>
         Não há texto de ajuda disponível.
        </Text>
       )}
       {description && (
        <Stack spacing='32px'>
         <Text
          as='span'
          fontSize='sm'
          lineHeight='28px'
          dangerouslySetInnerHTML={{ __html: description }}
         />
         {validUrl && isExpanded ? <VideoFrame videoUrl={videoUrl} /> : null}
        </Stack>
       )}
      </AccordionPanel>
     </>
    )}
   </AccordionItem>
  </Accordion>
 );
}
